import './FixReviewsSection.css';
import { BOOK_DEMO_URL } from '../../constants/urls';
import fixReviewsImg from '../../assets/fix_reviews.svg';

const FIX_FEATURES = [
  {
    title: 'Win More Customers',
    description:
      'People trust businesses with strong reviews, and the right reputation makes you the obvious choice.',
    icon: 'customers',
  },
  {
    title: 'Boost Local Rankings',
    description:
      'Reviews help your business climb Google search results, putting you in front of more buyers.',
    icon: 'rankings',
  },
  {
    title: 'Build Trust Instantly',
    description:
      'Social proof from happy customers gives prospects confidence to choose you over competitors.',
    icon: 'trust',
  },
  {
    title: 'Stand Out On Google',
    description:
      'Reviews make your business the obvious choice over your competition.',
    icon: 'google',
  },
] as const;

function FeatureIcon({ type }: { type: (typeof FIX_FEATURES)[number]['icon'] }) {
  switch (type) {
    case 'customers':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M9 11a3 3 0 100-6 3 3 0 000 6zm6 0a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM2 20c0-2.8 3.1-5 7-5s7 2.2 7 5v1H2v-1zm11-8c2.8 0 5 1.6 5 3.6V17h-5v-1.4c0-1.2-.4-2.3-1.1-3.2.8-.2 1.6-.4 2.4-.4z"
          />
        </svg>
      );
    case 'rankings':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4 18h16M6 14l4-4 3 3 5-6"
          />
          <path fill="currentColor" d="M17 7h3v3" />
        </svg>
      );
    case 'trust':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M4 12c0-2.5 3.5-5 8-5s8 2.5 8 5-3.5 5-8 5-8-2.5-8-5zm4 0c0 1.1 1.8 2 4 2s4-.9 4-2-1.8-2-4-2-4 .9-4 2zm1.5 3.5c.8.6 1.6.9 2.5.9s1.7-.3 2.5-.9L12 20l-2.5-4.5z"
          />
        </svg>
      );
    case 'google':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2l2.2 6.8H21l-5.5 4 2.1 6.8L12 15.4 6.4 19.6l2.1-6.8L3 8.8h6.8L12 2z"
          />
        </svg>
      );
    default:
      return null;
  }
}

export function FixReviewsSection() {
  return (
    <section id="about" className="fix-reviews" aria-labelledby="fix-reviews-heading">
      <div className="container">
        <header className="fix-reviews__header">
          <h2 id="fix-reviews-heading" className="fix-reviews__title">
            How we fix that with reviews
          </h2>
          <p className="fix-reviews__intro">
            Reviews are one of the most under utilized growth levers in any businesses&apos; toolbox. In the past, this was a time consuming and slow process that took away valuable time from you and your team. As your trusted review partner, we get it running, then you never have to worry about reviews again.
          </p>
        </header>

        <div className="fix-reviews__grid">
          <ul className="fix-features">
            {FIX_FEATURES.map((feature) => (
              <li key={feature.title} className="fix-feature">
                <span className="fix-feature__icon">
                  <FeatureIcon type={feature.icon} />
                </span>
                <div className="fix-feature__body">
                  <h3 className="fix-feature__title">{feature.title}</h3>
                  <p className="fix-feature__text">{feature.description}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="fix-reviews__video-wrap">
            <img
              src={fixReviewsImg}
              alt="How we fix that with reviews"
              className="fix-reviews__video-image"
            />
          </div>
        </div>

        <div className="fix-reviews__ctas">
          <a href="#pricing" className="btn btn--primary btn--lg">
            Start getting reviews
          </a>
          <a
            href={BOOK_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--secondary btn--lg"
          >
            Book a demo
          </a>
        </div>
      </div>
    </section>
  );
}
